import * as z from 'zod';
import { createDocument, extendZodWithOpenApi } from 'zod-openapi';
extendZodWithOpenApi(z);
export * from './zod-openapi-helpers.js';
export { z };
export { extendZodWithOpenApi, createDocument };
/**
 * Convert to JSONSchema using OpenAPI 3.1 spec, which is a superset of JSONSchema Draft 2020-12
 * This is preferred over zod-to-json-schema because it allows for metadata such as title
 * and summary to be specified via the `.openapi()` method.
 */
export function zodToOas31Schema(zodSchema, zodDefinitions) {
    const oas = createDocument({
        openapi: '3.1.0', // Only 3.1 is basically fully compatible with JSON-schema
        info: { title: '', version: '' },
        components: { schemas: { ...zodDefinitions, schema: zodSchema } },
    });
    const { schema, ...definitions } = oas.components?.schemas ?? {};
    return {
        ...schema,
        // Normally jsonschema uses an idiomatic `definitions` key,
        // but we use `components.schemas` to not need to modify any and all refs
        ...(Object.keys(definitions).length && {
            components: { schemas: definitions },
        }),
        /**
         * Superset of the [JSON Schema Specification Draft 2020-12](https://json-schema.org/draft/2020-12/schema)
         * Technically at https://spec.openapis.org/oas/3.1/dialect/base, but many tools don't support meta schemas
         * so we forget it for now.
         */
        // $schema: 'https://json-schema.org/draft/2020-12/schema,'
        // $schema: 'https://spec.openapis.org/oas/3.1/dialect/base',
    };
}
/** `zCast<TOut>()` standalone */
export const zCast = (...args) => z.unknown(...args);
/** Alternative to zCast that only accepts Records as inputs */
export const zRecord = () => z.record(z.unknown());
export const zObject = () => z.object({});
//# sourceMappingURL=index.js.map